"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateGridGapStyles = exports.generateGridColumnStyles = void 0;
const generateStyles_1 = require("../../utils/generateStyles");
/**
 * Generates grid column CSS styles based on the provided columns.
 * @param {number | number[]} columns - The number of columns for the grid.
 * @returns {string} - The generated CSS string for grid columns.
 */
const generateGridColumnStyles = (columns) => {
    return (0, generateStyles_1.getStylesWithBreakpoints)(columns, (value) => `grid-template-columns: repeat(${value}, 1fr);`);
};
exports.generateGridColumnStyles = generateGridColumnStyles;
/**
 * Generates grid gap CSS styles based on the provided gap values.
 * @param {Dimensions | Dimensions[]} gap - The general gap values for the grid.
 * @param {Dimensions | Dimensions[]?} rowGap - The row-specific gap values. Falls back to `gap` if not provided.
 * @param {Dimensions | Dimensions[]?} columnGap - The column-specific gap values. Falls back to `gap` if not provided.
 * @returns {string} - The generated CSS string for grid gaps.
 */
const generateGridGapStyles = (gap, rowGap, columnGap) => {
    const gapStyles = (0, generateStyles_1.getStylesWithBreakpoints)(gap, (value) => `gap: ${value};`);
    const rowGapStyles = (0, generateStyles_1.getStylesWithBreakpoints)(rowGap || gap, (value) => `row-gap: ${value};`);
    const columnGapStyles = (0, generateStyles_1.getStylesWithBreakpoints)(columnGap || gap, (value) => `column-gap: ${value};`);
    return `${gapStyles} ${rowGapStyles} ${columnGapStyles}`;
};
exports.generateGridGapStyles = generateGridGapStyles;
//# sourceMappingURL=Grid.utils.js.map